import { FolderKanban, DollarSign, FileClock, CalendarClock } from "lucide-react";

const StatCard = ({ icon: Icon, label, value, accent = "red", testid }) => {
  const accentClasses =
    accent === "emerald"
      ? "text-emerald-400 border-emerald-400/30 bg-emerald-400/[0.03]"
      : "text-[#FF3355] border-[#FF3355]/30 bg-[#FF3355]/[0.03]";
  return (
    <div
      data-testid={testid}
      className="group relative bg-[#0d1117] border border-[#1F2833] p-6 hover:border-[#FF3355]/60 transition-all hover:scale-[1.015]"
    >
      <div className="flex items-start justify-between">
        <div>
          <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#C5C6C7]/70">
            {label}
          </div>
          <div className="mt-3 font-display text-3xl font-bold text-[#F5F5F7] tracking-tight">
            {value}
          </div>
        </div>
        <div
          className={`inline-flex items-center justify-center h-10 w-10 border ${accentClasses}`}
        >
          <Icon size={16} />
        </div>
      </div>
    </div>
  );
};

export default function PortalStats({ stats }) {
  return (
    <section className="max-w-[1400px] mx-auto px-6 lg:px-10 py-8" data-testid="portal-stats">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard
          icon={FolderKanban}
          label="Active Projects"
          value={stats.activeProjects}
          testid="stat-active-projects"
        />
        <StatCard
          icon={DollarSign}
          label="Monthly Spend"
          value={`$${stats.monthlySpend.toLocaleString()}`}
          accent="emerald"
          testid="stat-monthly-spend"
        />
        <StatCard
          icon={FileClock}
          label="Assets Ready for Approval"
          value={stats.pendingApprovals}
          testid="stat-pending-approvals"
        />
        <StatCard
          icon={CalendarClock}
          label="Next Deliverable"
          value={stats.nextDeliverable}
          accent="emerald"
          testid="stat-next-deliverable"
        />
      </div>
    </section>
  );
}
